<template>
    <div style="width: 100%">
        <AdminTools />
        <div class="flexContainer full what">
            <section id="sectionPrincipal">
                <section class="brand-list">
                    <section class="searchResultsWrapper">
                        <h1 class="headline uppercase">Single Sign On Systems</h1>
                        <section>
                            <div class="flexContainer ai-c jc-sb">
                                <div class="flexContainer ai-c jc-sb">
                                    <a tag="span" @click="openModal(null);" class="btnExp iBlock pointer txtCenter active fright">
                                        Add a SSO system
                                    </a>
                                </div>
                            </div>
                            <hr class="full mt10 separator" />
                            <div v-for="sso in SsoSystems" :key="sso.id" class="listDisplay rel full flexContainer fd-c ai-c jc-fs">
                                <div class="listDisplay rel full flexContainer fd-c ai-c jc-fs list">
                                    <div class="listDisplay full ai-c jc-sb flexContainer">
                                        <div class="flexContainer fd-c size1of6">
                                            <span class="listTitle uppercase center">{{ sso.name }}</span>
                                        </div>
                                        <div class="flexContainer fd-c size1of6">
                                            <ul class="domains" v-for="domain in sso.domains" v-bind:key="domain.name">
                                                <li>&#64;{{ domain.name }}</li>
                                            </ul>
                                        </div>
                                        <div class="flexContainer fd-c size1of6">
                                            <span class="center">Nbr of users: {{ sso.numberOfUsers }}</span>
                                        </div>
                                        <div class="flexContainer fd-c size1of6 content-button">
                                            <span class="roundedIcon pointer" @click="openModal(sso);"><i class="fas fa-pencil-alt"></i></span>
                                            <span class="roundedIcon pointer" @click="deleteSso(sso);"><i class="fas fa-trash-alt"></i></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </section>
                </section>
                <SsoSystemFormModal
                    v-if="isModalOpen"
                    v-bind:existingSsoSystem="SsoSystemInModal"
                    @modalClosed="onModalClose($event);"
                ></SsoSystemFormModal>
            </section>
        </div>
    </div>
</template>

<script>
import SsoSystemFormModal from "./SsoSystemFormModal";
import SsoSystemHttpService from "./SsoSystemHttpService";
import AdminTools from "../../adminTools/Admin";

export default {
    components: {
        SsoSystemFormModal,
        AdminTools
    },
    data() {
        return {
            SsoSystems: [],
            SsoSystemInModal: null,
            isModalOpen: false
        };
    },
    created() {
        this.fetchSsoSystems();
    },
    methods: {
        async fetchSsoSystems() {
            this.SsoSystems = [];
            try {
                this.SsoSystems = await SsoSystemHttpService.fetchSsoSystems();
            } catch (error) {
                this.$swal({
                    type: "error",
                    title: "An error occurred",
                    text: error.message
                });
            }
        },
        onModalClose() {
            this.fetchSsoSystems();
            this.isModalOpen = false;
        },

        openModal(ssoSystem) {
            this.SsoSystemInModal = ssoSystem;
            this.isModalOpen = true;
        },

        async deleteSso(ssoSystem) {
            let message = `Do you really want to delete the SSO system ${ssoSystem.name}?`;
            if (ssoSystem.numberOfUsers > 0) {
                message = `If you continue the SSO system ${ssoSystem.name} will be deleted. It is currently used by ${
                    ssoSystem.numberOfUsers
                } users !`;
            }
            if (window.confirm(message)) {
                try {
                    this.SsoSystems = await SsoSystemHttpService.deleteSsoSystem(ssoSystem);
                    this.fetchSsoSystems();
                } catch (error) {
                    this.$swal({
                        type: "error",
                        title: "An error occurred",
                        text: error.message
                    });
                }
            }
        }
    }
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// SsoSystemList.vue?7629e7d4